import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import TextInputAdapter from '../adapters/TextInput';
import { Flex } from 'foundations-components/components/Flex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { HideIcon } from 'foundations-assets';
import { getDataAttributes } from '../utils/getDataAttributes';
import useComponentMountMetric from '../metrics/useComponentMountMetric';
import { useProperty } from '../v2/hooks/useProperty';
import { useIsUngatedForDisplayOptimizedFormControl } from '../v2/hooks/useIsUngatedForDisplayOptimizedFormControl';
import { DISPLAY_OPTIMIZED_BLOCK_SIZE } from '../constants/DisplayOptimizedBlockSize';

// We narrow the props down here so we can use this in the formatter as well
// without specifying all the props possible on the input. Props should never be
// added here that are not provided in PropertyInputV2
import { jsx as _jsx } from "react/jsx-runtime";
const TooltipTitle = () => {
  const property = useProperty();
  if (property && property.label) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputHidden.noPermissionWithLabel",
      options: {
        propertyLabel: property.label
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataProperties.PropertyInputHidden.noPermission"
  });
};
const HiddenInput = () => {
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(TooltipTitle, {}),
    autoPlacement: true,
    children: /*#__PURE__*/_jsx(HideIcon, {
      size: "500",
      color: "icon-primary-disabled"
    })
  });
};
const PropertyInputHidden = props => {
  const {
    formControlUse
  } = props;
  useComponentMountMetric('PropertyInputHidden');
  const isUngatedForDisplayOptimizedFormControl = useIsUngatedForDisplayOptimizedFormControl();
  if (formControlUse === 'compact') {
    return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
      children: /*#__PURE__*/_jsx(TextInputAdapter, {
        disabled: true
      })
    }));
  }
  if (formControlUse === 'floating') {
    return /*#__PURE__*/_jsx(Flex, Object.assign({
      alignItems: "center",
      blockSize: isUngatedForDisplayOptimizedFormControl ? DISPLAY_OPTIMIZED_BLOCK_SIZE : undefined,
      display: "inline-flex"
    }, getDataAttributes(props), {
      children: /*#__PURE__*/_jsx(HiddenInput, {})
    }));
  }
  return /*#__PURE__*/_jsx("span", Object.assign({}, getDataAttributes(props), {
    children: /*#__PURE__*/_jsx(HiddenInput, {})
  }));
};
export default /*#__PURE__*/memo(PropertyInputHidden);